import React from "react";
import { Twelve   } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
    return <ShreeDayTable staticData={Twelve} chartData={chartData} />;
  
};

export default ShreeDay;
